export default {
  title: 'Частые вопросы путешественников',
  paymentAbroad: {
    question: 'Можно ли оплатить российской картой за рубежом?',
    answerHtml:
      'Да. Предоплату любой экскурсии можно сделать картой российского банка.<br />Картой зарубежного банка можно оплатить экскурсию за границей, стоимость которой указана в любой валюте, кроме рублей.<br />Оставшуюся часть оплачиваете наличными при встрече с гидом.',
  },
  askGuide: {
    question: 'Как задать вопросы гиду?',
    answer:
      'Вы можете задать вопросы в комментариях к заказу до внесения предоплаты. Обычно гиды отвечают в течение 2–4 часов.',
  },
  howToPay: {
    question: 'Как оплатить экскурсию?',
    intro: 'Оплата происходит в два этапа:',
    prepaidTitle: 'Предоплата на сайте.',
    prepaidText:
      'Вы вносите предоплату и таким образом бронируете время экскурсии или место в туре. До ее внесения место могут забронировать другие путешественники.',
    payGuideTitle: 'Оплата гиду.',
    payGuideBeforeLink:
      'Оставшуюся часть оплачиваете наличными при встрече с гидом. Возможность оплатить картой или в другой валюте можете обсудить с гидом заранее. Оплата многодневного тура происходит заблаговременно до начала путешествия. Этапы оплаты указаны',
    tourPageLink: 'на странице тура',
    payGuideAfterLink: 'либо уточняются гидом при создании заказа.',
    methodsIntro: 'Способы оплаты на сайте:',
    russianCardTitle: 'Картой российского банка',
    russianCardText: 'можно оплатить любую экскурсию;',
    foreignCardTitle: 'Картой зарубежного банка',
    foreignCardText: 'можно оплатить экскурсию, стоимость которой указана в любой валюте, кроме рублей.',
  },
  cancelled: {
    question: 'Что делать, если экскурсия не состоится?',
    answer:
      'По правилам Трипстера, экскурсия обязательно состоится, если день был отмечен зеленым в календаре. В случае форс-мажора напишите в поддержку — мы полностью вернем предоплату и предложим альтернативный вариант.',
  },
  refund: {
    question: 'Как вернуть деньги, если планы поменялись?',
    beforeLink:
      'Вы можете бесплатно отменить заказ за 48 часов до начала экскурсии. При отмене заказа за меньший срок предоплата не возвращается (за исключением случаев, указанных в ',
    policyLink: 'политике возврата',
    afterLink: ').',
    howToCancel:
      'Чтобы отменить экскурсию, перейдите на страницу своего заказа, нажмите кнопку отмены внизу страницы и следуйте инструкции. Если вы хотите отменить экскурсию уже после даты ее проведения, обратитесь в поддержку.',
  },
} as const;
